/**
 * Agence'O - search-bar
 * @author Guillaume Bouillon (Agence'O)
 * @created 29/04/2019
 */

(function ($) {

  $(document).on('click', '.search-bar__trigger', (e) => {
    e.preventDefault();
    let is_open = !JSON.parse($(e.currentTarget).attr('aria-expanded'));

    $('.search-bar').toggleClass('is-open');
    $(e.currentTarget).attr('aria-expanded', is_open);

    if (is_open) {
      $('.search-bar__input').focus();
    } else {
      $('.search-bar__input').blur();
    }
  });

  $(document).on('keyup', (e) => {
    // ESC key pressed
    if (e.keyCode === 27) {
      $('.search-bar').removeClass('is-open');
      $('.search-bar__trigger').attr('aria-expanded', false);
      $('.search-bar__input').blur();
    }
  });

}(jQuery));
